/**
 * @Author: v_jppjpeng
 * @Date: 2023-08-13 13:46:46
 * @Explain: 配置项
 */

import {
  ActionTypeEnum,
  TimeFormatOptionsProps,
} from '@/definition/common/data.d';

/* 文件类型 */
export const fileTypeOptions: any = {
  json: 'application/json',
  xml: 'text/xml',
  csv: 'text/csv',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

/** 时间格式 */
export const timeFormatOptions: TimeFormatOptionsProps[] = [
  {
    label: 'YYYY-MM-DD HH:mm',
    showFormatAmPm: 'YYYY-MM-DD a hh:mm',
    showFormatAll: 'YYYY-MM-DD HH:mm',
    showFormatYMD: 'YYYY-MM-DD',
    showFormatYMDHM: 'YYYY-MM-DD HH:mm',
    showFormatMD: 'MM-DD',
    showFormatHm: 'a hh:mm',
    componentFormat: 'YYYY-MM-DD',
    interfaceFormat: 'YYYY-MM-DD HH:mm:ss',
    interfaceFormatNew: 'YYYY-MM-DDTHH:mm:ss',
    value: '1',
  },
  {
    label: 'DD MMM YYYY hh:mm a',
    showFormatAmPm: 'DD MMM YYYY hh:mm a',
    showFormatAll: 'DD MMM YYYY hh:mm a',
    showFormatYMD: 'DD MMM YYYY',
    showFormatYMDHM: 'DD-MM-YYYY HH:mm',
    showFormatMD: 'DD MMM',
    showFormatHm: 'hh:mm a',
    componentFormat: 'DD-MM-YYYY',
    interfaceFormat: 'YYYY-MM-DD HH:mm:ss',
    interfaceFormatNew: 'YYYY-MM-DDTHH:mm:ss',
    value: '2',
  },
];

/** action 中英译 */
export const actionTextJson: Record<ActionTypeEnum, string> = {
  [ActionTypeEnum.ADD]: 'COMMON.NEWLY.ADDED', // '新增',
  [ActionTypeEnum.EDIT]: 'COMMON.EDIT', // '编辑',
  [ActionTypeEnum.DETAILS]: 'COMMON.DETAILS', // '详情',
  [ActionTypeEnum.PREVIEW]: 'COMMON.PREVIEW', // '预览',
  [ActionTypeEnum.COPY]: 'COMMON.COPY', // '复制',
};
